
import React from 'react';
import '../App.css';
import valor1 from '../img/respeto.png';
import valor2 from '../img/tolerancia.png';
import valor3 from '../img/compromiso.png';

function Valores() {
  return (
    <section id="valores" className="valores-section">
      <h2 className="valores-title">Valores</h2>
      <p className="valores-title">Nuestros Valores son...</p>

      <div className="valores-container">
        <div className="valor-card red">
          <h1>Respeto</h1>
          <img src={valor1} alt="Ícono Respeto" className="icon" />
          <p>
            Hace referencia a una actitud moral por la que se aprecia la dignidad de una persona y se considera su libertad 
            para comportarse tal cual es, de acuerdo con su voluntad, intereses, opiniones, sin tratar de imponer una 
            determinada forma de ser y de pensar. 
            En el proceso formativo y de desarrollo de nuestras y nuestros estudiantes, este valor se va construyendo a través 
            de la interacción social, cuidado medio ambiental y sostenibilidad, y es imprescindible interiorizarlo en cada individuo, 
            de manera gradual. Valoramos la libertad de ser y de pensar de cada individuo, sin pasar a llevar los derechos de 
            los demás, tomando relevancia el considerar los diferentes contextos en los que nos relacionamos, como sujetos, 
            insertos en una comunidad y en la sociedad. 
          </p>
        </div>

        <div className="valor-card blue">
          <h1>Tolerancia</h1>
          <img src={valor2} alt="Ícono Tolerancia" className="icon" />
          <p>
            Esta, es una virtud moral y política universal que implica el respeto mutuo e íntegro hacia las otras personas, la 
            aceptación de la diversidad de opinión, social, étnica, cultural y religiosa en un contexto de valoración de los 
            derechos humanos de todos y todas. 
            Nos ayuda a valorar las distintas formas de entender y posicionarse en la vida, siempre que no atenten contra los 
            derechos fundamentales de las personas. 
            Una posición activa de la Tolerancia incorpora una práctica que admite: oposición, reclamo o denuncia ante ciertas 
            actitudes, impugnando la intolerancia y considerando formativamente que este valor se pone a prueba diariamente 
            frente a las divergencias en las que nos vemos inmersos. 
          </p>
        </div>

        <div className="valor-card red">
          <h1>Compromiso</h1>
          <img src={valor3} alt="Ícono Compromiso" className="icon" />
          <p>
            Entenderemos este valor como un fenómeno biopsicosocial, que incorpora pensamientos, afectos y actitudes en 
            función del sentido de pertenencia de los miembros de la comunidad educativa, logrando apartarse a normas, reglas 
            y valores específicos que se establecen según acuerdos democráticos. Este valor nos permite realizar 
            voluntariamente esfuerzos considerables en beneficio del objeto de compromiso. 
          </p>
        </div>
      </div>

      <style jsx>{`
        .valores-container {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: center;
        }

        .valor-card {
          background: rgba(0,0,0,0.35);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border-radius: 16px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.35);
          padding: 25px;
          width: 350px; /* ancho igual que Sellos */
          text-align: center;
          color: #fff;
          transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.3s ease, color 0.3s ease;
        }

        .valor-card h1 {
          font-size: 1.9rem; /* título grande */
          margin-bottom: 15px;
        }

        .valor-card .icon {
          width: 100px;
          height: auto;
          margin-bottom: 15px;
        }

        .valor-card p {
          font-size: 1.25rem; /* contenido grande */
          line-height: 1.8;
          transition: color 0.3s ease;
        }

        .valor-card.blue {
          background: rgba(3, 49, 140, 0.45);
        }
        .valor-card.red {
          background: rgba(242, 5, 25, 0.45);
        }

        .valor-card:hover {
          transform: scale(1.03);
          background: rgba(255, 255, 255, 0.15);
        }

        .valor-card:hover h1 {
          color: #ffcc00;
        }

        .valor-card:hover p {
          color: #222;
        }

        .valores-title {
          font-size: 2rem;
          color: #fff;
          text-align: center;
          background: rgba(0,0,0,0.4);
          padding: 12px 25px;
          border-radius: 15px;
          backdrop-filter: blur(6px);
          text-shadow: 1px 1px 3px rgba(0,0,0,0.7);
          margin-bottom: 20px;
        }

        .valores-intro {
          text-align: center;
          color: #fff;
          margin-bottom: 40px;
        }

        @media (max-width: 960px) {
          .valor-card {
            width: 90%;
          }
        }
      `}</style>
    </section>
  );
}

export default Valores;
